import React from 'react';
import PropTypes from 'prop-types';
import LiteralCurrency from 'components/LiteralCurrency';
import { useTranslation } from 'react-i18next';

const OrderDetailTotalPrice = ({ className, totalPrice }) => {
  const { t } = useTranslation('Quote');

  return (
    <div className={className}>
      <div className="vat-literal">{t('no_vat_included')}</div>
      <div className="price-literal">
        <LiteralCurrency value={totalPrice} />
      </div>
    </div>
  );
};

OrderDetailTotalPrice.propTypes = {
  totalPrice: PropTypes.number,
};

OrderDetailTotalPrice.defaultProps = {
  totalPrice: 0,
};

export default OrderDetailTotalPrice;
